import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  Menu,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../utils/routes";

export const Navbar = () => {
  const renderCustomLink = (route: { title: string; path: string }) => {
    return (
      <Link
        style={{
          textDecoration: "none",
          color: "inherit",
          fontWeight: 600,
          fontFamily: "'Orbitron', sans-serif",
          fontSize: "0.8rem",
          letterSpacing: "1px",
        }}
        to={route.path}
      >
        {route.title}
      </Link>
    );
  };

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        background: "rgba(3, 8, 15, 0.7)",
        backdropFilter: "blur(10px)",
        borderBottom: "1px solid rgba(0, 242, 255, 0.2)",
        marginBottom: "2rem",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Avatar
            sx={{
              display: { xs: "none", md: "flex" },
              mr: 2,
              filter: "drop-shadow(0 0 5px #00f2ff)",
            }}
            alt="Star Wars"
            src="https://cdn.icon-icons.com/icons2/2622/PNG/512/scifi_starwars_imperial_icon_158236.png"
          />
          <Typography
            variant="h6"
            noWrap
            component={Link}
            to="/"
            sx={{
              mr: 4,
              display: { xs: "none", md: "flex" },
              fontFamily: "'Syncopate', sans-serif",
              fontWeight: 700,
              letterSpacing: ".2rem",
              color: "#00f2ff",
              textDecoration: "none",
              textShadow: "0 0 10px rgba(0, 242, 255, 0.5)",
            }}
          >
            GALACTIC ARCHIVE
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="menu"
              onClick={handleOpenNavMenu}
              color="primary"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
                "& .MuiPaper-root": {
                  background: "rgba(3, 8, 15, 0.95)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid #00f2ff",
                },
              }}
            >
              {routes.map((route, index) => (
                <Box key={index} sx={{ px: 3, py: 1.5 }}>
                  {renderCustomLink(route)}
                </Box>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component={Link}
            to="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "'Syncopate', sans-serif",
              fontWeight: 700,
              letterSpacing: ".2rem",
              color: "#00f2ff",
              textDecoration: "none",
            }}
          >
            G.A.
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "flex-end",
              gap: "2rem",
            }}
          >
            {routes.map((route, index) => (
              <Box
                key={index}
                sx={{
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    filter: "drop-shadow(0 0 8px #00f2ff)",
                  },
                }}
              >
                {renderCustomLink(route)}
              </Box>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
